module.exports = __webpack_public_path__ + "img/house2_icon.bf9b144b.png";